import { Box, Grid } from "@mui/material";
import { ReferenceListItem, ViewReference } from "./Components";
import { useReferences } from "./Hooks";
import { IReferences } from "./Interfaces";
import { DataGridLoading, StateMessage } from "Common/Components";

export const References = (props: IReferences) => {
  const { isCollapsedReference, resetReference, pageResetKey, handleDocumentView } = props;

  const {
    referencesError,
    viewError,
    references,
    selectedReference,
    setSelectedReference,
    setActiveParagraphReference,
    pageNumber,
    setParagraphs,
    modifiedPdfUrl,
    isReferencesListFetching,
    isReferenceLoading,
    warningMessage,
  } = useReferences(props);

  return (
    <Box
      sx={{
        position: { md: "relative" },
        height: "100%",
        flexShrink: { xs: 1, md: 0 },
        flexGrow: { xs: 1, md: 0 },
        backgroundColor: "#fff",
      }}
    >
      <DataGridLoading isLoading={isReferencesListFetching}>
        <>
          {(referencesError || viewError) && !isCollapsedReference && !selectedReference && (
            <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
              <StateMessage message={"Error occurred"} secondaryMessage={"An error occurred while loading references."} />
            </Box>
          )}

          {!referencesError && references?.length === 0 && !isCollapsedReference && (
            <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
              <StateMessage message={"No Data to Display"} secondaryMessage="This list has no data." />
            </Box>
          )}

          {!referencesError && references && references.length !== 0 && !selectedReference && (
            <Box sx={{ maxHeight: `calc(100vh - 120px)` }}>
              <Grid sx={{ width: "100%", pt: 5 }}>
                {references.map((reference) => (
                  <ReferenceListItem
                    key={reference.fileId}
                    onClick={() => handleDocumentView(reference.fileUrl, 1)}
                    title={reference.title}
                    description={reference.description}
                    fileLink={reference.fileUrl}
                    fileName={reference.fileName}
                    fileType={reference.fileType}
                  />
                ))}
              </Grid>
            </Box>
          )}
          {selectedReference && (
            <ViewReference
              isLoading={isReferenceLoading}
              onClick={() => {
                setSelectedReference(undefined);
                resetReference();
                setActiveParagraphReference(undefined);
                setParagraphs(undefined);
              }}
              reference={selectedReference}
              initialPage={pageNumber}
              modifiedUrl={modifiedPdfUrl}
              pageResetKey={pageResetKey}
              warningMessage={warningMessage}
            />
          )}
        </>
      </DataGridLoading>
    </Box>
  );
};
